// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "root-3i6O0";
var _3 = "header-2sCQZ";
var _4 = "card-_oob5";
var _5 = "content-10KAN";
var _6 = "description-2Hi_8";
var _7 = "label-BLE5b";
var _8 = "serviceHeader-74yBR";
var _9 = "cost-1ndxA";
var _a = "price-2LPbl";
export { _1 as "__esModule", _2 as "root", _3 as "header", _4 as "card", _5 as "content", _6 as "description", _7 as "label", _8 as "serviceHeader", _9 as "cost", _a as "price" }
export default { "__esModule": _1, "root": _2, "header": _3, "card": _4, "content": _5, "description": _6, "label": _7, "serviceHeader": _8, "cost": _9, "price": _a }
